import * as React from "react";
import DataImage from "../../DataImage";
import {IFoodBanksProps} from "../../utils/models";
import makeSum from "../../../../utils/makeSum";
import image from '../../asset/2. Charitable organisations.png'

const CharitableOrganisations = ({ submissions }: IFoodBanksProps) => {
    return (
        <DataImage
            image={image}
            value={makeSum(submissions, 'number_of_charitable_organisations')}
            text="Number of charitable organisations"
        />
    );
}

export default CharitableOrganisations;